import { Component, computed, ElementRef, inject, viewChild, ViewEncapsulation } from '@angular/core';
import { DragHandleComponent } from "../../../../../../../../shared/drag-handle/drag-handle.component";
import { TranslateModule } from '@ngx-translate/core';
import { SignPaymentCardComponent } from './components/sign-payment-card/sign-payment-card.component';
import { LoggedPaymentCardComponent } from "./components/logged-payment-card/logged-payment-card.component";
import { MPassService } from './services/mpass.service';

@Component({
  selector: 'app-make-payment',
  standalone: true,
  imports: [
    TranslateModule,
    DragHandleComponent,
    SignPaymentCardComponent,
    LoggedPaymentCardComponent,
],
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MakePaymentComponent {
  public makePaymentRef = viewChild<ElementRef>('makePaymentRef');
    
  private mpassService = inject(MPassService);
  public isQrGenerated = computed(() => this.mpassService.qrLocatorImage());

}
